
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M9 0C4.04 0 0 4.04 0 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 1.688A7.3 7.3 0 0116.313 9 7.3 7.3 0 019 16.312 7.3 7.3 0 011.688 9 7.3 7.3 0 019 1.687z","font-family":"sans-serif","overflow":"visible"}}),_c('path',{attrs:{"d":"M10.705 5.28a1.014 1.014 0 00-.727 1.733l.972.972H4.612a1.014 1.014 0 100 2.028h6.338l-.972.972a1.014 1.014 0 000 1.436c.397.398 1.04.398 1.437 0 .907-.906 2.415-2.45 2.415-2.45s.569-.42.572-.972c.003-.545-.56-.98-.56-.98s-1.624-1.64-2.427-2.443a1.016 1.016 0 00-.71-.296z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    